import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// Services
import { DashboardService } from '../../services/dashboard.service';
import { ModuleService } from '../../services/modules.service';
import { StorageService } from '../../services/storage.service';

// Models
import { Blog } from '../../models/blog';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-blogs-list',
  templateUrl: './blogs-list.component.html',
  styleUrls: ['./blogs-list.component.scss', './blogs-list.component.medium.scss']
})
export class BlogsListComponent implements OnInit {

  constructor(private moduleService: ModuleService,
    private dashboardService: DashboardService,
    private storageService: StorageService,
    private router: Router
  ) { }


  get isBlogsAvailable() {
    return this.moduleService.isBlogAvailable();
  }

  blogsArray = null;
  isLoadingBlogs = null;

  ngOnInit() {
    if (this.isBlogsAvailable) {
      const blogs = this.getBlogs();
      if (blogs) {
        this.pushBlogs();
      } else {
        this.isLoadingBlogs = true;
        const dashboard: any = this.dashboardService.getDashboard();
        dashboard.
          $observable
          .subscribe(
          () => {
            this.storageService.setBlogs(dashboard.blogs);
            this.pushBlogs();
            this.isLoadingBlogs = false;
          },
          err => {
            this.router.navigate(['/error']);
            throw err;
          }
          );
      }
    }
  }

  getBlogs(): any {
    return JSON.parse(localStorage.getItem('blogs'));
  }

  getImgUrl(id: any) {
    return `${environment.url.onlineResourcesStaticUrl}${id}.jpg`;
  }

  imgError(e) {
    //why is this empty?
  }

  pushBlogs() {
    const blogs = this.getBlogs();
    this.blogsArray = [];
    blogs.forEach(blog => {
      const newBlog: Blog = new Blog(blog);
      this.blogsArray.push(newBlog);
    });
    this.isLoadingBlogs = false;
  }

  goToBlog(id) {
    this.router.navigate(['/io-news/', id]);
  }
}
